import { acetateSpec } from '../config/acetates';

/** Supplier reference of a library acetate (Notion « Réf »), for the workshop; null for « Original ». */
export function acetateRef(id: string): string | null {
  return acetateSpec(id)?.ref ?? null;
}
